function ForageRunControls({ evaluation, paused, speed, onPause, onRestart, onSpeedChange }) {
    return (
        <aside className="forage-controls forage-run-controls">
            <div className="forage-controls-heading">
                <div>
                    <p>Run controls</p>
                    <span>The learned policy is frozen. No training occurs while you watch.</span>
                </div>
            </div>

            <label className="forage-control" htmlFor="forage-playback-speed">
                <span>
                    <span>Playback speed</span>
                    <output htmlFor="forage-playback-speed">{speed}×</output>
                </span>
                <input
                    id="forage-playback-speed"
                    aria-label="Playback speed"
                    type="range"
                    min="0.5"
                    max="2"
                    step="0.5"
                    value={speed}
                    onChange={(event) => onSpeedChange(event.target.value)}
                />
            </label>

            <div className="forage-run-summary">
                <div><span>Status</span><strong>{evaluation.complete ? 'Complete' : paused ? 'Paused' : 'Running'}</strong></div>
                <div><span>Action selection</span><strong>Highest value</strong></div>
                <div><span>Exploration</span><strong>Off</strong></div>
            </div>

            <div className="forage-actions">
                <button
                    type="button"
                    className="forage-primary-action"
                    onClick={evaluation.complete ? onRestart : onPause}
                >
                    {evaluation.complete ? 'Run again' : paused ? 'Continue run' : 'Pause run'}
                </button>
                <button type="button" onClick={onRestart}>New run</button>
            </div>
        </aside>
    );
}

export default ForageRunControls;
